<template>
  <span class="app-input__error">
    {{ message }}
  </span>
</template>

<script>
export default {
  name: 'AppInputError',

  props: {
    message: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.app-input__error {
  display: inline-block;
  font-size: 13px;
  color: var(--c-bright-red-500);
  margin-top: 5px;
}
</style>
